import Icon from '../components/Icon.vue'

Icon.register({
  pager: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64h-384c-35.3 0-64-28.7-64-64v-256c0-35.3 28.7-64 64-64h384zM160 368v-48h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80zM288 352v-16c0-8.8-7.2-16-16-16h-80v48h80c8.8 0 16-7.2 16-16zM448 224v-64c0-17.7-14.3-32-32-32h-320c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pager.js
// module id = 1603
// module chunks = 0